/* eslint-disable prettier/prettier */
/* eslint-disable arrow-body-style */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/extensions */
import React, { ReactElement } from "react";
import Tippy from "@tippyjs/react";
import styled from "styled-components";
import { redesignTheme } from "../theme/theme";
import "tippy.js/dist/tippy.css";

type AutoPlacement = "auto" | "auto-start" | "auto-end";
export type VariationPlacement =
  | "top-start"
  | "top-end"
  | "bottom-start"
  | "bottom-end"
  | "right-start"
  | "right-end"
  | "left-start"
  | "left-end";
export type BasePlacement = "top" | "bottom" | "right" | "left";
export type Placement = AutoPlacement | BasePlacement | VariationPlacement;

type TooltipProps = {
  children: ReactElement;
  content: string;
  placement: Placement;
};

const StyledTooltip = styled(Tippy)`
    &.tippy-box {
      margin: 0;
      padding: 0;
      max-width: 240px;
      border-radius: ${redesignTheme.radius.sm};
      background: ${redesignTheme.color.gray900};
    }
    &.tippy-box[data-placement^=${(props) =>
      props.placement}] > .tippy-arrow::before {
        border-${(props): string => props.placement}-color: ${
  redesignTheme.color.gray900
};
    }
`;

const StyledChildren = styled.span`
  max-width: 100%;
`;

const StyledContent = styled.p`
  margin: 0;
  padding: ${redesignTheme.spacing[1.5]} ${redesignTheme.spacing[2.5]}
  font-family: ${redesignTheme.fontFamily.interface};
  font-size: ${redesignTheme.fontSize[50]};
  color: ${redesignTheme.color.white};
  font-weight: ${redesignTheme.fontWeight.normal};
  line-height: 20px;
`;

const Tooltip = ({
  children,
  content,
  placement,
}: TooltipProps): ReactElement => {
  return (
    <StyledTooltip
      content={<StyledContent>{content}</StyledContent>}
      placement={placement}
    >
      <StyledChildren>{children}</StyledChildren>
    </StyledTooltip>
  );
};

export default Tooltip;
